import React, { useState, useEffect, useRef } from 'react'
import { Select, Button, Card, Modal, Form, message } from 'antd'
import _ from 'lodash'
import { paginationInit, formatMessageNew, dateTrans, initCurryingObj } from '@/utils/common'
import { modalConfirm, modalError } from '@/utils/modalUtils'
import { regEmail } from '@/utils/regUtils'
import { hasPermission } from '@/annotations/nike-react'
import { getEmailPage, modifyStatus, addOrEditEmail, resendEmail } from '@/services/Email/EmailManagement'
import { EMAIL_MANAGEMENT_STATUS } from '@/utils/types'
import AntdTable from '@/components/table/AntdTable'
const menu_email_management_config = 'menu_email_management_config'
const button_email_management_resend = 'button_email_management_resend'

const statusObj = initCurryingObj(EMAIL_MANAGEMENT_STATUS)
const EmailManagement = () => {
  let editRowObjData = useRef({})
  const [newModalForm] = Form.useForm()
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [statusFlag, setStatusFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selecteOptions, setSelecteOptions] = useState([])
  const [selecteDefaultOptions, setSelecteDefaultOptions] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)

  const tableColumns = [
    { type: 'selection', fixed: 'left', width: 0 },
    {
      title: formatMessageNew('languageObj.emailManagement.emailEvent'),
      dataIndex: 'emailEvent',
      width: 200,
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailManagement.systemName'),
      dataIndex: 'systemName',
      width: 100,
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailManagement.exceptionType'),
      dataIndex: 'exceptionType',
      width: 180,
      render: (text, record) => {
        return (
          <div className="word_break_word">
            <div>{record.exceptionCode}</div>
            <div>{record.exceptionType}</div>
          </div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.emailManagement.emailEventStatus'),
      dataIndex: 'emailEventStatus',
      width: 130,
      render: text => {
        return <div className="word_break_word">{statusObj[text]}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailManagement.emailReceiver'),
      dataIndex: 'emailReceiver',
      width: 230,
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailManagement.emailSendStatus'),
      dataIndex: 'sendStatus',
      width: 130,
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailManagement.lastSendTime'),
      dataIndex: 'lastSendTime',
      width: 120,
      render: text => {
        return <div className="word_break_word">{text && dateTrans(text, true)}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.operation'),
      dataIndex: 'opt',
      width: 160,
      fixed: 'right',
      align: 'center',
      type: 'opt',
      render: (text, record) => {
        return (
          <div className="opt">
            <Button
              disabled={
                !hasPermission(button_email_management_resend) || record.sendStatus === 'Success' ? true : false
              }
              onClick={() => {
                resendRow(record)
              }}
              type="primary"
            >
              {formatMessageNew('languageObj.commonLocale.resend')}
            </Button>
            <Button
              disabled={!hasPermission(menu_email_management_config)}
              onClick={() => {
                editRow(record)
              }}
              type="primary"
            >
              {formatMessageNew('languageObj.commonLocale.edit')}
            </Button>
          </div>
        )
      }
    }
  ]
  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  useEffect(() => {
    if (selectedRowKeys.length === 0 && statusFlag) setStatusFlag(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowKeys])

  const editRow = record => {
    newModalForm.resetFields()
    setVisibleFlag(true)
    editRowObjData.current = record
    let obj = {
      email: []
    }
    if (record.emailReceiver) {
      let ls = record.emailReceiver.split(',')
      obj.email = ls
      let valueList = []
      if (ls) {
        for (let index = 0; index < ls.length; index++) {
          const element = ls[index]
          let valObj = {
            value: element,
            label: element
          }
          if (!regEmail.test(element)) {
            valObj.err = true
          } else {
            valObj.err = false
          }
          valueList.push(valObj)
        }
      }
      // 初始化下拉框原始内容
      setSelecteDefaultOptions(ls)
      // 初始化下拉框数据
      setSelecteOptions(valueList)
    }
    newModalForm.setFieldsValue(obj)
  }
  const resendRow = record => {
    const params = {
      emailConfigId: record.id
    }
    resendEmail(params).then(() => {
      message.success(formatMessageNew('languageObj.commonLocale.success'))
      setQueryFlag(!queryFlag)
    })
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    const params = {
      emailEventStatus: '',
      pageNo: pagination.currentPage,
      size: pagination.pageSize
    }
    getEmailPage(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const disabledDataFun = () => {
    modalConfirm(
      {
        content: statusFlag
          ? formatMessageNew('languageObj.emailManagement.enableEmailDataTip')
          : formatMessageNew('languageObj.emailManagement.disabledEmailDataTip')
      },
      () => {
        const params = []
        for (let index = 0; index < tableList.length; index++) {
          const element = tableList[index]
          if (selectedRowKeys.indexOf(element.id) !== -1) {
            params.push(element.id)
          }
        }
        modifyStatus({
          idList: params,
          status: statusFlag ? 'Active' : 'InActive'
        }).then(() => {
          message.success(formatMessageNew('languageObj.commonLocale.success'))
          setSelectedRowKeys([])
          setQueryFlag(!queryFlag)
        })
      }
    )
  }
  const handleUserOk = () => {
    newModalForm
      .validateFields()
      .then(values => {
        const params = {
          id: editRowObjData.current.id,
          emailReceiverList: values.email
        }

        addOrEditEmail(params)
          .then(() => {
            message.success(formatMessageNew('languageObj.commonLocale.success'))
            setQueryFlag(!queryFlag)
            setVisibleFlag(false)
          })
          .catch(err => {
            const errorCode = err.errorCode
            let str = 'languageObj.httpLocale.requestError'
            if (errorCode === '3001' || errorCode === '3002') {
              str = 'languageObj.emailManagement.error_' + errorCode
            }
            modalError({
              content: formatMessageNew(str)
            })
          })
      })
      .catch(errorInfo => {
        console.log('errorInfo', errorInfo)
      })
  }
  const handleUserCancel = () => {
    setVisibleFlag(false)
  }
  const onSelectChange = newSelectedRowKeys => {
    const matchedObjects = _.filter(tableList, obj => _.includes(newSelectedRowKeys, obj.id))
    let allFalse = _.every(matchedObjects, ['emailEventStatus', 'InActive'])
    let allTrue = _.every(matchedObjects, ['emailEventStatus', 'Active'])
    if (allFalse) {
      // 全是false则启用
      setStatusFlag(true)
    } else if (allTrue) {
      // 全是true则禁用
      setStatusFlag(false)
    } else {
      // 有true，有false则禁用
      setStatusFlag(false)
    }
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div>
          {hasPermission(menu_email_management_config) ? (
            <div>
              <Button
                type="primary"
                danger={!statusFlag}
                disabled={!hasSelected}
                className="mt10 ml20"
                onClick={() => {
                  disabledDataFun()
                }}
              >
                {statusFlag
                  ? formatMessageNew('languageObj.commonLocale.enable')
                  : formatMessageNew('languageObj.commonLocale.disable')}
              </Button>
            </div>
          ) : null}
        </div>
        <div className="content-container overflow_visible">
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的表示，不能重复
            columnsKey="emailManagementColumns"
            pagination={pagination}
            onChange={handleTableChange}
            rowSelection={hasPermission(menu_email_management_config) && rowSelection}
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        centered
        maskClosable={false}
        className="nike_modal"
        width="50%"
        title={formatMessageNew('languageObj.emailManagement.addOrEdit')}
        onOk={handleUserOk}
        onCancel={handleUserCancel}
        destroyOnClose
      >
        <div className="modal_body_height">
          <Form
            name="basic"
            form={newModalForm}
            labelCol={{
              span: 4
            }}
            wrapperCol={{
              span: 20
            }}
            initialValues={{}}
          >
            <Form.Item
              rules={[
                {
                  validator: (_, value) => {
                    let valueList = []
                    if (value) {
                      let errorFlag = false
                      let ls = selecteDefaultOptions.concat(value)
                      // 校验输入内容，初始化下拉框不可移除
                      ls = Array.from(new Set(ls))
                      for (let index = 0; index < ls.length; index++) {
                        const element = ls[index]
                        let valObj = {
                          value: element,
                          label: element
                        }
                        if (!regEmail.test(element)) {
                          errorFlag = true
                          valObj.err = true
                        } else {
                          valObj.err = false
                        }
                        valueList.push(valObj)
                      }
                      setSelecteOptions(valueList)
                      if (errorFlag) {
                        return Promise.reject(
                          new Error(formatMessageNew('languageObj.userManagementLocale.checkFormat'))
                        )
                      } else {
                        return Promise.resolve()
                      }
                    } else {
                      return Promise.resolve()
                    }
                  }
                }
              ]}
              label={formatMessageNew('languageObj.emailManagement.email')}
              name="email"
            >
              <Select
                className="nikeSelectH"
                mode="tags"
                placeholder={
                  formatMessageNew('languageObj.commonLocale.placeholderInput') +
                  ' ' +
                  formatMessageNew('languageObj.emailManagement.email')
                }
                style={{
                  width: '100%'
                }}
              >
                {selecteOptions.map(itemSel => {
                  return (
                    <Select.Option key={itemSel.value} value={itemSel.value}>
                      {itemSel.err ? (
                        <span className="link_name_dashboard_error">{itemSel.label}</span>
                      ) : (
                        <span>{itemSel.label}</span>
                      )}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  )
}
export default EmailManagement
